import { h } from "preact";
import { useEffect, useState } from "preact/hooks";

import BackButton from "./BackButton.jsx";
import Button from "./Button.jsx";
import ErrorState from "./ErrorState.jsx";

import products from "../api/products";
import { sendError } from "../errors.js";

/**
 * This is shown when the user sees the result the first time.
 */
export default function QuestionnaireResultDisclaimer(props) {
  const [data, setData] = useState({});
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(async () => {
    // TODO: Same as in QuestionnairResult.jsx
    try {
      setError(null);
      setData(await products.fetch(props.qnaireId));
    } catch (err) {
      sendError(err);
      // TODO: some handing is needed here
      setError(err);
    }
    setLoaded(true);
  }, []);

  if (!loaded) return null;

  return (
    <section class="questionnaire-result-disclaimer">
      <div class="mb-2">
        {error && <ErrorState />}
        <h1 class="questionnaire-result-disclaimer__headline">Thank you.</h1>
        <p class="questionnaire-result-disclaimer__text">
          {data.product
            ? "We have found a residence permit that suits your requirements."
            : "We did not find any residence permit matching your requirements."}
        </p>

        <p class="questionnaire-result-disclaimer__disclaimer">
          Please note, we are not a law firm and not a substitute for the advice
          of an attorney.
        </p>
      </div>
      {props.onBack && (
        <BackButton class="mr-2" noIndent onClick={props.onBack} />
      )}
      <Button type="submit" onClick={props.onNext}>
        Continue
      </Button>
    </section>
  );
}
